import React from "react";
import { connect } from "react-redux";
import "../css/digitalSection.css";

const DigitalSection = ({ digitalSectionData }) => {
  if (!digitalSectionData) return null;

  return (
    <div className="digital-section" style={{ backgroundColor: "#a65d00" }}>
      <div className="digital-section-inner">
        {/* LEFT SIDE – TEXT */}
        <div className="digital-section-content fade-in">
          <h1 className="title">{digitalSectionData.heading}</h1>
          <p className="subtitle">{digitalSectionData.paragraph}</p>

          <div className="case-studies">
            {digitalSectionData.case_studies.map((study, index) => (
              <div className="case-study" key={index}>
                <h3 className="twopara">{study.title}</h3>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE – IMAGE */}
        <div className="digital-section-image-wrapper">
          <img
            src={digitalSectionData.banner_image}
            alt="Digital evolution visual"
            className="digital-section-image"
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  digitalSectionData: state.digitalSection.data,
});

export default connect(mapStateToProps)(DigitalSection);
